// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jcNx5","title":"_2MWKc","price":"_2f_JG"};